import { render, staticRenderFns } from "./FunnelStudio.vue?vue&type=template&id=fde87ce2&scoped=true"
import script from "./FunnelStudio.vue?vue&type=script&lang=js"
export * from "./FunnelStudio.vue?vue&type=script&lang=js"
import style0 from "./FunnelStudio.vue?vue&type=style&index=0&id=fde87ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde87ce2",
  null
  
)

export default component.exports